export default (function () {
  return {
    init() {
      this.scrollToNext();
    },

    scrollToNext() {
      const sectionBtn = document.querySelectorAll('.js-next-section');

      if (sectionBtn.length === 0) return;

      sectionBtn.forEach((btn) => {
        const section = btn.closest('.masthead');

        if (section !== null) {
          const scrollToElement = section.nextElementSibling;

          if (scrollToElement === null) {
            btn.classList.add('hidden');
          } else {
            btn.addEventListener('click', (e) => {
              scrollToElement.scrollIntoView({
                behavior: 'smooth',
              });
            });
          }
        }
      });
    },
  };
})();
